import Vue from 'vue';
import App from './App.vue';
import router from './router';
import api from './services/auth-api';
import VueCookies from 'vue-cookies';
import BootstrapVue from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import Vue2Datepicker from 'vue2-datepicker'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import NProgress from 'nprogress'
import vue2Dropzone from 'vue2-dropzone'
import { quillEditor } from 'vue3-quill'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import 'nprogress/nprogress.css'
import 'vue-snotify/styles/material.css' 
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import 'vue-select/dist/vue-select.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import fr from 'vue2-datepicker/locale/fr';
import '@/styles/index.scss';


Vue.use(BootstrapVue);
Vue.use(VueCookies); 
Vue.component('v-select', vSelect)
Vue.component('Vue-date-picker', Vue2Datepicker)
Vue.component('apexChart', VueApexCharts)
Vue.component('vue-dropzone',vue2Dropzone);
Vue.use(quillEditor)


Vue.use(Snotify, {
  toast: {

    position: SnotifyPosition.centerTop, 
    timeout: 3000,
    showProgressBar: false,
    closeOnClick: true,
    bodyMaxLength: 150,
    titleMaxLength: 30,
    icon:false,
    backdrop:0.5

  },
    global: {
    maxOnScreen: 5,
    maxAtPosition: 5,
    newOnTop: true,
    preventDuplicates:true

  }
})


NProgress.configure({ showSpinner: false, speed: 1000 })



Vue2Datepicker.defaultProps = {
  language: fr,
  format: 'DD-MM-YYYY HH:mm',
  valueType: 'string',
  placeholder: 'Sélectionner une date',
  editable: true,
  clearable: true,
  confirm: false,
  appendToBody: true,
  inline: false,
  inputClass: 'custom-input-class',
  disabled: false,
  range: false,
  shortcuts: [],
  showWeekNumber: false,
  showHour: false,
  showMinute: false,
  showSecond: false,
  use12h: false,
  timeTitleFormat: 'DD-MM-YYYY HH:mm',
  rangeSeparator: ' ~ ',
  titleFormat: 'DD-MM-YYYY HH:mm',
};



Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$nprogress = NProgress;

Vue.config.errorHandler = (err) => {
    console.error('[Vue Error Handler]', err);
  };


new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
